import * as v from 'valibot';
import { AccountCreationSchema } from '@api/io/account.io';
import wretch from 'wretch';
import { localizedErrorHandlers } from '@fe-core';

type TAccountCreationRequest = v.Input<typeof AccountCreationSchema>;
export type TAccountCreatePayload = {
  email: string;
  redirect: string;
};
export const create = async ({
  baseUrl,
  sessionId,
  payload,
}: {
  baseUrl: string;
  sessionId: string;
  payload: TAccountCreatePayload;
}): Promise<TAccountCreationRequest> => {
  const url = `${baseUrl}/selfreg/sessions/${sessionId}/register`;
  const instance = wretch(url, {
    credentials: 'include',
  }).post(payload);

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(AccountCreationSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | create account | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid create account response');
    }
  });
};
